// formatDuration.js

/**
 * Converts a duration in minutes to a formatted string like "1h 30m" or "45m".
 * @param {number|string} minutes - The duration in minutes.
 * @returns {string} Formatted duration string.
 */
export function formatDuration(minutes) {
  const duration = parseInt(minutes, 10);
  if (isNaN(duration) || duration <= 0) return '';

  const hours = Math.floor(duration / 60);
  const mins = duration % 60;

  const hourStr = hours > 0 ? `${hours}h` : '';
  const minStr = mins > 0 ? `${mins}m` : '';

  return [hourStr, minStr].filter(Boolean).join(' ').trim();
}
